import {
    CLAUSE_LIST,
    CLAUSES_CATEGORY_TYPE_LIST,
    CLAUSE_TYPE_LIST,
    CLAUSE_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getClausesCategoryTypeList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        const url = `v1/Clauses/GetClausesCategoryType`;
        return APICall('get', payload, url).then(result => {
            console.log('ddddddddddddddddd', result);
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CLAUSES_CATEGORY_TYPE_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: CLAUSE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetClauseTypeList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        const url = `v1/Clauses/GetClauseType`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CLAUSE_TYPE_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: CLAUSE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetClauseList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetClauseList?${queryParams}`;
        const url = `v1/Clauses/GetClauseList?${queryParams}`;
        return APICall('get', payload, url).then(result => {

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CLAUSE_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: CLAUSE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const CreateClauses = (payload) => {
    const url = `v1/Clauses/InsertClauses`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            // const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateClauses = (payload) => {
    const url = `v1/Clauses/UpdateClauses`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DeleteClauses = (payload) => {
    const url = `v1/Clauses/DeleteClause`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};



/**
 * https://api.shipez.ai/api/v1/CountryClause/GetCountryDetail
 * @param {*} payload 
 * @returns 
 */
export const GetClausebyCountryName = (countryName) => {
    const url = `v1/CountryClause/GetCountryDetail?CountryName=${encodeURIComponent(countryName)}`;

    return APICall('get', null, url)
        .then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject(result);
            }
        })
        .catch(error => Promise.reject(error));
};